import styled from 'styled-components'

import { mq, sizes } from '../../../theme'
import RecipeIngredient from '../../atoms/RecipeIngredient'
import Icon from '../../atoms/Icon'

export const Container = styled.section`
  display: flex;
  width: 100%;
  flex-direction: column;
  border-radius: 1rem;
  background-color: ${({ theme }) => theme.colors.linen};
  padding: 3rem 1rem 1.5rem;
  gap: 3rem;
  @media ${mq(sizes.tablet)} {
    padding: 3rem 2rem;
  }
`

export const Head = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media ${mq(sizes.tablet)} {
    flex-direction: row;
    align-items: center;
    gap: 7rem;
    /* justify-content: space-between; */
  }
`

export const Title = styled.h2`
  ${({ theme }) => theme.textStyles.titleH3};
  margin: 0;
  color: ${({ theme }) => theme.colors.arapawa};
  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.titleH2};
  }

  @media print {
    ${({ theme }) => theme.textStyles.titleH5};
  }
`

export const NbOfPeople = styled.span`
  ${({ theme }) => theme.textStyles.textMediumStrong};
  color: ${({ theme }) => theme.colors.arapawa};
  display: flex;
  align-items: center;
`

export const PeopleIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.ruby};
  width: 3.2rem;
  height: 3.2rem;
  margin-right: 0.5rem;
`

export const Ingredients = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  @media ${mq(sizes.tablet)} {
    flex-direction: row;
    gap: 4rem;
  }
`

export const IngredientsColumn = styled.ul`
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 1.5rem;
  &:last-of-type > *:last-of-type {
    border-bottom: none;
    padding-bottom: 0;
  }
  @media ${mq(sizes.tablet)} {
    &:first-child:after {
      content: '';
      position: absolute;
      border-right: 1px solid ${({ theme }) => theme.colors.gainsboro};
      top: 0;
      bottom: 0;
      right: -2rem;
    }
    width: calc(50% - 2rem);
    & > *:last-of-type {
      border-bottom: none;
      padding-bottom: 0;
    }
  }
`

export const Ingredient = styled(RecipeIngredient)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.gainsboro};
`
